import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import { useInit } from "../Router/InitContext";

export const ProfissionalSetor = ({
  onChangeSetor,
  onChangeProfissional,
  setorAtendimento = {},
  profissional = {},
  gridSetorProps = {},
  textFieldSetorProps = {},
  textFieldProfissionalProps = {},
  gridProfissionalProps = {},
  profissionalAdicional = [],
  onChangeProfissionaisAdicionais,
  readOnly = false,
}) => {
  const { setoresAtendimento, profissionais, isLoading } = useInit();
  const [profissionaisSetor, setProfissionaisSetor] = useState([]);

  const allowMultipleProfissionais = !!onChangeProfissionaisAdicionais;
  const hasMultipleProfissionais = profissionalAdicional.length > 0;
  const profissionaisSelected = [...profissionalAdicional];

  if (profissional?.nome) profissionaisSelected.unshift(profissional);

  useEffect(() => {
    setProfissionaisSetor(
      profissionais.filter((p) =>
        p.setor_atendimentos.some((s) => s.id === (setorAtendimento || {}).id)
      )
    );
  }, [setorAtendimento, isLoading]);

  return (
    <>
      <Grid item {...gridSetorProps}>
        <Autocomplete
          options={setoresAtendimento}
          value={setorAtendimento}
          getOptionLabel={(option) => option.nome || ""}
          onChange={(e, value) => {
            onChangeSetor(e, value);
            onChangeProfissional(e, null);
            onChangeProfissionaisAdicionais?.(e, []);
          }}
          fullWidth
          readOnly={readOnly}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Setor"
              variant="outlined"
              required
              {...textFieldSetorProps}
            />
          )}
        />
      </Grid>
      <Grid
        item
        {...gridProfissionalProps}
        sx={{ display: "flex", alignItems: "center", gap: 1 }}
      >
        <Autocomplete
          multiple={allowMultipleProfissionais}
          options={profissionaisSetor}
          value={
            allowMultipleProfissionais ? profissionaisSelected : profissional
          }
          getOptionLabel={(option) =>
            option.nome || option.profissional?.nome || ""
          }
          onChange={(e, values) => {
            if (allowMultipleProfissionais) {
              onChangeProfissional(e, values[0]);
              onChangeProfissionaisAdicionais(e, values.slice(1));
              return;
            }
            onChangeProfissional(e, values);
          }}
          fullWidth
          // required doesn't work for multi value autocomplete, so here I'm basically checking whether the information was provide or not
          required={!profissional?.id}
          readOnly={readOnly}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Profissional"
              variant="outlined"
              helperText={
                hasMultipleProfissionais
                  ? "Atendimento realizado por mais de um profissional"
                  : ""
              }
              {...textFieldProfissionalProps}
            />
          )}
          noOptionsText="Nenhum profissional disponível"
          helperText="test"
        />
      </Grid>
    </>
  );
};
